<template>
  <div class="flight_info bg-g3 flex" :class="StateFlightTextBG">
    <div>
      <span>
        {{ StateFlightText }}
      </span>

      <svg class="text-g0" viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor" aria-hidden="true">
        <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"></path>
      </svg>
    </div>
    <div>
      <span class="!flex items-center">
        {{ $e("Étapes") }} {{ StateFlightState }}
        <span class="i group ml-2" :class="StateFlightTextBG">
          i
          <span
            class="absolute top-[29px] left-[-87px] bg-g3 px-[10px] w-max max-w-[245px] py-[5px] hidden group-hover:flex items-center drop-shadow-xl"
            :class="StateFlightTextBG">
            <span class="text-sm">
              {{ StateFlightStateDescription }} </span>
          </span>
        </span>
      </span>

      <svg class="text-g0" viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor" aria-hidden="true">
        <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"></path>
      </svg>
    </div>
    <div>
      <span> {{ StateFlightPercent }} % </span>
    </div>
  </div>
</template>


<script>
import { ref } from "vue";
import { toast } from "vue3-toastify";
import API from "@/utils/API.js";
import Map from "@/utils/Map.js";
import Timer from "@/utils/Timer.js";

export default {
  name: "Flight_Flight",
  props: {
    flight: Object,
    config: Object,
  },
  setup() {
    return {
      flightstatus: ref(false),
    };
  },

  mounted() {
  },

  methods: {
  },

  computed: {
    StateFlightText() {
      var flightStatus = this.config?.flight?.data?.status !== undefined
        ? this.config.flight.data.status
        : "Inactif";

      return Object.hasOwnProperty.call(this.$root.status_flight, flightStatus)
        ? this.$root.status_flight[flightStatus]
        : flightStatus;
    },

    StateFlightTextBG() {
      var flightStatus = this.config?.flight?.data?.status !== undefined
        ? this.config.flight.data.status
        : "";

      /**
       * "failed": "Échoué",
       * "in_progress": "En cours",
       * "ok": "Terminé",
       */

      switch (flightStatus) {
        case "failed":
          return "!bg-error";
        case "in_progress":
        case "null":
          return "!bg-warning";
        case "ok":
          return "!bg-success";
        default:
          return "";
      }
    },

    StateFlightState() {
      return this.config?.flight?.data?.step != undefined
        ? this.config.flight.data.step
        : 0;
    },

    StateFlightStateDescription() {
      let step = this.config?.flight?.data?.step != undefined
        ? this.config.flight.data.step
        : 0;

      return Object.hasOwnProperty.call(this.$root.status_flight_etapes, step)
        ? this.$root.status_flight_etapes[step]
        : 'Inactif';
    },

    StateFlightPercent() {
      return this.config?.flight?.data?.percent != undefined
        ? this.config.flight.data.percent
        : 0;
    },
  },
};
</script>
